import { PartnerUserRole } from '@/lib/models/partner-user.model';
import { createContext } from 'react';

export type FeatureFlags = {
  canChangeAuth: boolean;
};

export type FeatureSettings = FeatureFlags & {
  partnerUserRole: PartnerUserRole;
  getTooltip: (feature: FeatureId) => string;
  hasFeature: (feature: string) => boolean;
  loading: boolean;
};

export type FeatureFlag = keyof FeatureFlags;

export type FeatureId = 'change-auth';

export const FeatureContext = createContext<FeatureSettings>({
  partnerUserRole: 'partner:auditor',
  getTooltip: () => '',
  hasFeature: () => false,
  loading: false,
  canChangeAuth: false,
});
